<div (click)="logVersionToSentry()" class="logo-section">
  <div class="logo">
    <img src="../../assets/images/logo.png" alt="logo" />
    <img
      src="../../assets/images/logo-title.png"
      alt="logo-title"
      class="logo-second"
    />
  </div>

  <div class="row white-text">приложение экспедитора</div>
</div>

<div class="form form-container">
  <form [formGroup]="loginForm" (keyup.enter)="login()">
    <br />
    <app-base-input
      [type]="'email'"
      [control]="loginForm.controls['email']"
      [placeholder]="'E-mail'"
      [roundCorner]="true"
      formControlName="email"
      style="width: 100%"
    ></app-base-input>
    <br />
    <app-base-input
      [type]="'password'"
      [control]="loginForm.controls['password']"
      [placeholder]="'Пароль'"
      [roundCorner]="true"
      formControlName="password"
      style="width: 100%"
    ></app-base-input>

    <div class="error-section">
      <span class="error" *ngIf="loginProcessError">
        <ng-container [ngSwitch]="loginResponseCode">
          <ng-template ngSwitchCase="204">
            Пользователь не зарегистрирован в системе.
          </ng-template>
          <ng-template ngSwitchCase="401">
            Неверные логин или пароль.
          </ng-template>
          <ng-template ngSwitchCase="406">
            Пожалуйста, подтвердите регистрацию по ссылке из отправленного письма.
          </ng-template>
          <ng-template ngSwitchDefault>
            В процессе авторизации возникла ошибка. Проверьте правильность введенных
            данных.
          </ng-template>
        </ng-container>
      </span>
      <span class="error" *ngIf="accessDeniedError">
        Вход доступен только экспедиторам.
      </span>
    </div>
    <br />
    <ion-button
      class="large"
      mode="md"
      (click)="login()"
      [disabled]="loginForm.invalid || isLoading"
      >
      <div class="login-text">
        <ion-spinner *ngIf="isLoading" name="crescent"></ion-spinner>
        <span>Войти</span>
      </div>
    </ion-button
    >

    <div
      (click)="openRegistration()"
      class="row green-text registration-margin"
    >
      <a>Регистрация</a>
    </div>
  </form>
</div>

<div (click)="restorePassword()" class="row green-text">
  <a>Восстановить пароль</a>
</div>

<div style="position: absolute; bottom: 0; right: 10px">{{ version }}</div>
